import {
    apiRequest,
    PromotionPegawaiList as list,
    kenaikanpangkaInactive,
    PromotionDeleteSKC,
    exportTemplateKenaikanPangkat,
    importDataKenaikanPangkat
} from "../../../../../services/adapters/kepegawaian/kenaikanpangkatService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", list, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    
    fetchInactive = async (query) => {
        return await apiRequest("post", kenaikanpangkaInactive, {
            body: query
        }, true)
    }
    fetchInactiveSK = async (query) => {
        return await apiRequest("post", PromotionDeleteSKC, {
            body: query
        }, true)
    }

    fetchexportTemplateKenaikanPangkat = async (query) => {
        return await apiRequest("get", exportTemplateKenaikanPangkat, {
            params: query
        }, true)
    }

    fetchimportDataKenaikanPangkat = async (query) => {
        return await apiRequest("post", importDataKenaikanPangkat, {
            body: query
        }, true)
    }
  

}

export default DataTableRepository